import { EventSamplePoint } from 'types/models/notification';
import SamplePoint from 'types/models/samplePoint';

export const convertSamplePointToEventSamplePoint = (samplePoint: SamplePoint): EventSamplePoint => {
  return {
    id: samplePoint.id,
    sid: samplePoint.sid,
    name: samplePoint.name,
    siteId: samplePoint.siteId,
    deviceId: samplePoint.deviceId
  };
};